export const Space = ({ numOfSpaces = 1 }: { numOfSpaces?: number }) => {
  const spaces = Array(numOfSpaces).fill(0);
  return (
    <>
      {spaces.map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: No stable key available for spaces
        <span key={i}>&nbsp;</span>
      ))}
    </>
  );
};

export default Space;
